/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */
import * as React from 'react';
import * as Mui from 'mui';
import { PageTitle } from 'components';

/** Loading */
export class Loading extends React.Component {
  constructor(props: any, ctx: any) {
    super(props, ctx);
  }

  render() {
    return (
      <div className="column fill center middle spinner">
        <PageTitle>Loading</PageTitle>
      </div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/views/loading/index.tsx